module.exports = __webpack_public_path__ + "fonts/nucleo-icons.c1733565.eot";